module.exports = __webpack_public_path__ + "static/media/solicite.883e8ddd.png";